import { render, staticRenderFns } from "./HeroPricing.vue?vue&type=template&id=0fe78868&"
import script from "./HeroPricing.vue?vue&type=script&lang=js&"
export * from "./HeroPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports